import { Component, OnInit } from "@angular/core";
import { NgbCalendar, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import * as data from "../../../shared/data/dashboard/default";
import { CandidateService } from "src/app/shared/services/candidate.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {

  dashboard:any;
  public purchase = data.purchase
  public salesReturn = data.salesReturn
  public sales = data.sales
  public purchaseRate = data.purchaseRate
  defaultUrl="https://www.youtube.com/embed/Rx97n3RdvpI?si=pev3ACzaYtgi-0fW";
  sourceUrl:any;

  constructor(calendar: NgbCalendar,private candidateService:CandidateService,    private sanitizer: DomSanitizer,
    ) {
    this.candidateService.getDashboard().subscribe(result=>{

      this.dashboard=result.data;

      // Assurez-vous d'initialiser les autres propriétés si nécessaire
      this.purchase = this.dashboard.formationValid;
      this.salesReturn = this.dashboard. formatDo;
      this.sales = this.dashboard.formationFalse;
      this.purchaseRate = this.dashboard.interviewProgram;
      this.sourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/Rx97n3RdvpI?si=pev3ACzaYtgi-0fW');
      this.defaultUrl=this.dashboard?.videoUrl;

      if(this.dashboard?.videoUrl){
        this.sourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dashboard.videoUrl);

      }


    })
  }

  ngOnInit() {}

  

 

  
}
